import API from "./API";

async function doCreatePaymentIntent(subscription_id, user_id) {
    return API.post(`/users/${user_id}/subscriptions/${subscription_id}/purchase`);
}

async function doGetPaymentIntent(payment_intent) {
    return API.get(`/website/payments/payment_intent/${payment_intent}`);
}

export {
    doCreatePaymentIntent,
    doGetPaymentIntent,
}